import {
  AbsenceIcon,
  Button,
  ClassbookIcon,
  CoursesIcon,
  DashboardIcon,
  FileIcon,
  GroupsIcon,
  HomeIcon,
  HomeworkIcon,
  MediathekIcon,
  MeetingDefaultIcon,
  ProfileIcon,
  QuestionmarkCircleIcon,
  SettingsIcon,
  Sidebar,
  TemplatesIcon,
} from '@bp/ui-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { DesktopContext } from '../../context/IsDesktop';
import { useAuthClaims } from '../../hooks/useAuthClaims';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

export const MobileMenuFlyout = () => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const organization = pimAuthClaims.getOrganization();
  const location = useLocation();
  const perms = usePermissionChecker();

  return (
    <Sidebar
      isDesktop={false}
      currentLocationPath={location.pathname}
      logoType={'bildungsplattform'}
      sidebarContent={[
        {
          title: t('common.forMe'),
          items: [
            {
              icon: <DashboardIcon />,
              link: '',
              title: t(`dashboard.title`),
            },
            {
              icon: <CoursesIcon />,
              link: 'courses',
              title: t(`courses.title`),
            },
            {
              icon: <GroupsIcon />,
              link: 'groups',
              title: t(`groups.title`),
            },
            ...(perms?.canViewClassbook(organization)
              ? [
                  {
                    icon: <ClassbookIcon />,
                    link: 'classbook',
                    title: t(`classbook.title`, { count: 1 }),
                  },
                ]
              : []),

            ...(perms?.canViewHomeworks(organization)
              ? [
                  {
                    icon: <HomeworkIcon />,
                    link: 'homeworks',
                    title: t('homeworks.title', { count: 2 }),
                  },
                ]
              : []),
            ...(perms?.canViewAbsences()
              ? [
                  {
                    icon: <AbsenceIcon />,
                    link: 'absences',
                    title: t(`absences.title`, { count: 2 }),
                  },
                ]
              : []),
            ...(perms?.canViewTemplates()
              ? [
                  {
                    icon: <TemplatesIcon />,
                    link: 'templates',
                    title: t(`templates.title`),
                  },
                ]
              : []),
          ],
        },
        ...(perms?.canViewMediaLibrary()
          ? [
              {
                title: 'Community',
                items: [
                  {
                    icon: <MediathekIcon />,
                    link: 'mediaLibrary',
                    title: t(`mediaLibrary.title`),
                  },
                ],
              },
            ]
          : []),

        {
          title: t('institution.general'),
          items: [
            {
              icon: <HomeIcon />,
              link: 'institution',
              title: t('institution.title'),
            },
            ...(perms?.canViewMeetings(organization)
              ? [
                  {
                    icon: <MeetingDefaultIcon />,
                    link: 'meetings',
                    title: t('meetings.titlesShort'),
                  },
                ]
              : []),
            ...(perms?.canViewSettings(organization)
              ? [
                  {
                    icon: <SettingsIcon />,
                    link: 'settings',
                    title: t('settings.title'),
                  },
                ]
              : []),
          ],
        },
      ]}
      sidebarFooterItems={[
        {
          icon: <ProfileIcon />,
          link: 'profile',
          title: t('profiles.titleSingular'),
        },
        ...(perms?.canViewAdmin()
          ? [
              {
                icon: <SettingsIcon />,
                link: 'admin',
                title: 'Administration',
              },
            ]
          : []),

        {
          icon: <QuestionmarkCircleIcon />,
          link: 'app-about',
          title: t('common.about'),
        },
      ]}
      isExpanded={true}
      isFixed={false}
      setIsFixed={() => {
        return;
      }}
      setIsExpanded={() => {
        return;
      }}
    />
  );
};
